import View from './View'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'


class IndexView extends View {

  constructor(id) {
    super(id)
  }
  /**
  * animate in (show)
  **/  
  show(container) {
    super.show(container)
    
    const items = [...container.querySelectorAll(".index-section .section-inner")]
    items.forEach((el, index) => {
      const del = index * .2;
      const letter = el.querySelector(".index-letter .letter-inner")
      const elements = [...el.querySelectorAll(".item-box .inner")]
      const t = new TimelineMax({repeat: 0})
      t.set(el, {opacity: 1, y: 0})
      t.set(letter, {opacity: 1, y: 0, x: 0})
      t.set(elements, {opacity: 1, y: 0})
      t.from(el, .05, {opacity: 0, delay: del})
      t.from(el, .4, {y: -200, delay: del, ease: Power4.easeOut}, 0)
      t.from(letter, .4, {x: -60, opacity: 0, ease: Power4.easeOut}, .3)
      t.from(elements, .4, {y: 30, opacity: 0, delay: (i) => i * .1, ease: Power4.easeOut}, .3)
    })
    
    
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container)
    
    const items = [...container.querySelectorAll(".index-section .section-inner")]
    items.forEach((el, index) => {
      const del = index * .07;
      const letter = el.querySelector(".index-letter .letter-inner")
      const elements = [...el.querySelectorAll(".item-box .inner")]
      const t = new TimelineMax({repeat: 0})
      
      t.to(letter, .4, {x: -60, opacity: 0, ease: Power4.easeIn}, 0)
      t.to(elements, .4, {y: 30, opacity: 0, delay: (i) => i * .05, ease: Power4.easeIn}, 0)
      t.to(el, .4, {y: -200, delay: del, ease: Power4.easeIn}, .3)
      t.to(el, .05, {opacity: 0, delay: del}, .55)
    })
    
    
  }

}

export default IndexView